<template>
  <div class="sudi-container">
    <custom-router-link :item="info" class="sudi-link" :to="{name: 'HomeDetails', params: {id: info.id}}" target="_blank">
      <span class="title" v-if="title">{{title}}</span>
      <el-image :src="projectFileUrl + info.image" fit="cover" v-if="info.image"></el-image>
      <el-image :src="require('@/assets/images/img3.png')" fit="cover" v-else></el-image>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    },
    title: {
      type: String,
      default: ""
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.sudi-container {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    padding: 6px 12px;
    background: rgba(201, 212, 216, 0.5);
    color: #fff;
    font-size: 14px;
    border-radius: 0 0 10px 0;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  }
  .sudi-link {
    width: 100%;
    height: 100%;
    display: block;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.1);
    .el-image {
      width: 100%;
      height: 100%;
    }
  }
}

@media screen and (max-width: 768px) {
  .sudi-container {
    .title {
      padding: 4px 10px;
      font-size: 12px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>